import React from 'react';
import Checkbox from '../../forms/Checkbox';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import { UserContext } from '../../../Application';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';

const ReviewFooter = ({
    loggedIn,
    signed,
    signName,
    signEmail,
    isPublic,
    saveAsDraft,
    canSubmit,
    hasComments,
    toggleSign,
    onNameChange,
    onEmailChange,
    signFunction,
    onFunctionChange,
    submit
}) => (
    <div className="ckp-contracts-review-footer">
        <UserContext.Consumer>
            {user =>
                hasPermissions(user, PERMISSIONS.SIGN_CONTRACTS_INBOX) || isPublic ? (
                    <div className="ckp-contracts-review-sign">
                        <div className="ckp-grid-row">
                            <div className="ckp-grid-column">
                                <Input
                                    disabled={hasComments && loggedIn}
                                    value={signName}
                                    onChange={onNameChange}
                                    label="Full name *"
                                />
                            </div>
                            <div className="ckp-grid-column">
                                {!loggedIn && <Input value={signEmail} onChange={onEmailChange} label="Email *" />}
                            </div>
                            <div className="ckp-grid-column">
                                <Input
                                    disabled={hasComments && loggedIn}
                                    value={signFunction}
                                    onChange={onFunctionChange}
                                    label="Function"
                                />
                            </div>
                        </div>
                        <Checkbox
                            name="sign-contract"
                            disabled={hasComments}
                            onChange={toggleSign}
                            checked={signed}
                            label="I hereby sign and agree to this contract."
                        />
                        {hasComments ? (
                            <p className="ckp-contracts-review-no-sign">
                                You cannot sign the contract when comments are given.
                            </p>
                        ) : null}
                    </div>
                ) : null
            }
        </UserContext.Consumer>
        <UserContext.Consumer>
            {user =>
                hasPermissions(user, PERMISSIONS.COMMENT_CONTRACTS_INBOX) || isPublic ? (
                    <div className="ckp-grid-row is-center">
                        {isPublic ? null : (
                            <p className="u-text-center u-margin-2">
                                <Button
                                    className="is-secondary is-small"
                                    onClick={saveAsDraft}
                                    label="Save as Draft"
                                    inactive={signed || signName || !hasComments}
                                />
                            </p>
                        )}
                        <p className="u-text-center u-margin-2">
                            <Button className="is-small" onClick={submit} label="Send" inactive={!canSubmit} />
                        </p>
                    </div>
                ) : null
            }
        </UserContext.Consumer>
    </div>
);

export default ReviewFooter;



// WEBPACK FOOTER //
// ./src/components/application/contracts/ReviewFooter.js